<script setup lang="ts">
import { useStatsigEventsStore } from '@apps/main/new-desktop/core/stores';

import { TransportType } from '@libs/trip-planner-interfaces';

import type { ItineraryUpsellNoTransportSegment } from '../../models';
import { useTripOverviewPageStore } from '../../stores';

import TransportBanner from './upsell/TransportBanner.vue';

interface ItineraryUpsellNoTransportSegmentProps {
  segment: ItineraryUpsellNoTransportSegment;
}

const props = defineProps<ItineraryUpsellNoTransportSegmentProps>();

const tripOverviewPageStore = useTripOverviewPageStore();
const statsigEventsStore = useStatsigEventsStore();

function selectTransport(transport: TransportType): void {
  tripOverviewPageStore.selectTransport(props.segment, transport);
}

function onTransportBannerClose(): void {
  tripOverviewPageStore.selectTransport(props.segment, TransportType.None);
  statsigEventsStore.logTripOverviewTransportBannerCloseButtonClicked();
}
</script>

<template>
  <TransportBanner
    :country="segment.destination"
    @add-flight="selectTransport(TransportType.Flight)"
    @add-ferry="selectTransport(TransportType.Ferry)"
    @select-transport="selectTransport($event)"
    @close="onTransportBannerClose"
  />
</template>
